import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
import isEmpty from "lodash/isEmpty";

// Components
import Loader from '../../../utils/Loader';
import Select from 'react-select';
import AdminTopTierCustomersEdit from './AdminTopTierCustomersEdit';
import DataSearchTable from './DataSearchTable';

import { loadTopTiers, loadCustomers } from '../../../../store/actions/topTier';
import { addRoute } from '../../../../store/actions/route';
import { setpageTitle } from '../../../../store/actions/siteInfo'

class AdminTopTierCustomers extends Component{
    constructor(props){
        super(props)
        this.state = {
            topTierSelected: {},
            topTierIndex: null,
            q: ''
        }

        this.props.addRoute(this.props.match)
        this.props.setpageTitle('Top Tier Customers')
    }

    componentDidMount(){
        this.props.loadTopTiers();
        this.props.loadCustomers();
    }

    handleSelectBoxChange = (id) => {
        if(id === null)
            this.props.loadCustomers();

        this.setState({   
            topTierIndex: id,
            topTierSelected: this.props.topTiers[id],
        }, 
        () => { this.props.loadTopTiers() });
    }

    render(){
        const { topTierSelected, topTierIndex } = this.state;
        const { topTiers, topTiersLoading } = this.props;

        // Select Box Values
        const topTierOptions = [
            {value: null, label: '--- ALL CUSTOMERS ---'}
        ];
        let i = 0;
        !isEmpty(topTiers) && topTiers.forEach(element => {
            topTierOptions.push({value: i++, label: element.name});
        })

        return (
            <Fragment>
                <h1>Top Tier Customers</h1>
                <div className="instruction">Top Tiers can be assigned customers who are eligible for that top tier's discount, if one is set. Each customer can only be assigned to one top tier at a time. Select a top tier from the dropdown box to start adding customers.</div>

                {/* Loading */
                topTiersLoading ? 
                <div className="pt2 pb2">
                    <Loader />
                </div> :
                /* Page Content */
                <Fragment>
                    {!!topTiers && topTiers.length <= 0 ? <div>There are currently no top tiers to display.</div> :
                    <Fragment>
                        {/* Top Tier Select Box */}
                        <div className="tt-prod-select">
                            <div className="tt-prod-select-label">Select Top Tier:</div>
                            <Select className="select-box" 
                                placeholder={'--- ALL CUSTOMERS ---'}
                                name={`top_tier_id`} 
                                value={topTierIndex} 
                                onChange={selection => this.handleSelectBoxChange(selection.value)} 
                                clearable={false} 
                                valueKey="value"
                                labelKey="label" 
                                options={topTierOptions} 
                            />
                        </div>
                        <hr className="tt-hr-divider"/>
                        {/* Load Edit Component */}
                        {topTierIndex != null 
                        ? <AdminTopTierCustomersEdit topTier={topTierSelected} /> :
                        this.props.allCustomersLoading ?
                        <Loader /> :
                        <Fragment>
                            <h2>All Customers</h2>
                            <DataSearchTable
                                format={[
                                    {header: 'First Name', property: 'fname'},
                                    {header: 'Last Name', property: 'lname'},
                                    {header: 'Email', property: 'email'},
                                    {header: 'Top Tier', property: 'name'}
                                ]}
                                searchProperties={['fname', 'lname', 'email', 'name']}
                                data={!!this.props.allCustomers ? this.props.allCustomers : []}
                                showRowNumbers={true}
                                itemsPerPage={10}
                                type={'customers'}
                                notification={'No results. Type into the searchbar to query all products.'}
                                searchQuery={this.state.q}
                                storeSearch={(q) => this.setState({q: q})}
                                // clickAction={(type, data) => this.getDataOnClick(type, data)}
                                // clickActionText={'Add'}
                            />
                        </Fragment>
                        }
        
                    </Fragment>
                    }
                </Fragment>
                }
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        topTiers: state.topTier.topTiers,
        topTiersLoading: state.topTier.topTiersLoading,
        allCustomers: state.topTier.allCustomers,
        allCustomersLoading: state.topTier.allCustomersLoading
    }
}

export default connect(mapStateToProps, {addRoute, setpageTitle, loadTopTiers, loadCustomers})(AdminTopTierCustomers)


// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/AdminTopTierCustomers.js